
import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
    Frequency : {
        ...genStandard("frequency","/api/md"),
    } 
};
export default api;